// Keyboard navigation for nav-menu containers.
// Supports ArrowUp/ArrowDown to move between links, Home/End to jump to
// first/last link, and Escape to close the parent collapsed section.
document.addEventListener("DOMContentLoaded", () => {
  const menuContainers = document.querySelectorAll(".nav-menu");

  menuContainers.forEach((menuContainer) => {
    menuContainer.addEventListener("keydown", (e) => {
      const focusableItems = Array.from(
        menuContainer.querySelectorAll("a[href]")
      );
      const currentIndex = focusableItems.indexOf(document.activeElement);

      if (currentIndex === -1) return;

      let nextIndex;

      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          nextIndex = (currentIndex + 1) % focusableItems.length;
          focusableItems[nextIndex].focus();
          break;

        case "ArrowUp":
          e.preventDefault();
          nextIndex =
            (currentIndex - 1 + focusableItems.length) % focusableItems.length;
          focusableItems[nextIndex].focus();
          break;

        case "Home":
          e.preventDefault();
          focusableItems[0].focus();
          break;

        case "End":
          e.preventDefault();
          focusableItems[focusableItems.length - 1].focus();
          break;

        case "Escape":
          e.preventDefault();
          {
            const collapseEl = menuContainer.closest(".nav-dropdown.collapse, .mobile-training-menu.collapse");
            if (collapseEl && typeof $ !== "undefined") {
              const triggerId = collapseEl.getAttribute("id");
              const trigger = document.querySelector(
                '[data-target="#' +
                  triggerId +
                  '"], [aria-controls="' +
                  triggerId +
                  '"]'
              );
              $(collapseEl).collapse("hide");
              if (trigger) {
                trigger.classList.remove("active");
                trigger.focus();
              }
            }
          }
          break;

        default:
          break;
      }
    });
  });

  // Helper to resolve the collapse target element from a trigger button.
  function getCollapseTarget(trigger) {
    var menuId =
      trigger.getAttribute("data-target") ||
      trigger.getAttribute("aria-controls");
    if (!menuId) return null;
    return document.getElementById(menuId.replace(/^#/, ""));
  }

  // Helper to get the visible text label of a trigger element.
  function getTriggerLabel(trigger) {
    return trigger.textContent.replace(/\s+/g, " ").trim();
  }

  // Announce expanded/collapsed state to screen readers via the existing live region.
  function announceState(trigger, expanded) {
    var liveRegion = document.getElementById("x508-sr-alert");
    if (!liveRegion) return;
    var label = getTriggerLabel(trigger);
    var state = expanded ? "expanded" : "collapsed";
    liveRegion.textContent = "";
    setTimeout(function () {
      liveRegion.textContent = label + ", " + state;
    }, 100);
  }

  // Listen for Bootstrap collapse events to announce state changes.
  if (typeof $ !== "undefined") {
    $(".nav-dropdown.collapse").on("shown.bs.collapse", function () {
      var id = this.getAttribute("id");
      var trigger = document.querySelector(
        '[data-target="#' + id + '"], [aria-controls="' + id + '"]'
      );
      if (trigger) announceState(trigger, true);
    });

    $(".nav-dropdown.collapse").on("hidden.bs.collapse", function () {
      var id = this.getAttribute("id");
      var trigger = document.querySelector(
        '[data-target="#' + id + '"], [aria-controls="' + id + '"]'
      );
      if (trigger) announceState(trigger, false);
    });
  }

  // For navigation trigger buttons:
  // - ArrowDown opens the menu and focuses the first link.
  // - Escape closes the menu if it is open.
  const menuTriggers = document.querySelectorAll(
    '[role="button"][data-toggle="collapse"]'
  );

  menuTriggers.forEach((trigger) => {
    trigger.addEventListener("keydown", (e) => {
      if (e.key === "ArrowDown") {
        e.preventDefault();

        var menuContainer = getCollapseTarget(trigger);
        if (!menuContainer) return;

        // Open the collapse if not already open
        if (typeof $ !== "undefined" && !$(menuContainer).hasClass("show")) {
          $(menuContainer).collapse("show");
        }

        const links = menuContainer.querySelectorAll("a[href]");
        if (links.length > 0) {
          setTimeout(() => links[0].focus(), 150);
        }
      }

      if (e.key === "Escape") {
        var collapseEl = getCollapseTarget(trigger);
        if (!collapseEl) return;

        if (typeof $ !== "undefined" && $(collapseEl).hasClass("show")) {
          e.preventDefault();
          $(collapseEl).collapse("hide");
          trigger.classList.remove("active");
          trigger.focus();
        }
      }
    });
  });

  // Escape key on the profile dropdown
  const profileDropdown = document.querySelector(
    ".user-profile-dropdown .dropdown-menu"
  );
  if (profileDropdown) {
    profileDropdown.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        const trigger = document.getElementById("user-dropdown-link");
        if (typeof $ !== "undefined") {
          $(trigger).dropdown("toggle");
        }
        if (trigger) trigger.focus();
      }
    });
  }

  // After page load, move focus to main content so VoiceOver
  // does not auto-read through the entire navigation.
  var mainContent = document.getElementById("content");
  if (mainContent) {
    mainContent.setAttribute("tabindex", "-1");
    mainContent.style.outline = "none";
    mainContent.focus({ preventScroll: true });
  }
});
